import { useTranslation } from 'next-i18next';

// BV-1586: nhãn dưới giá đã giảm của dòng giỏ ("ราคาหลังหักส่วนลด").
// Tách component để chỉ dùng namespace cart khi dòng giỏ thật sự có priceAfterVoucher
// (ProductCardBuy còn được dùng ở các trang không tải namespace cart).
const CartPriceAfterVoucherLabel = ({ className = '' }) => {
  const { t } = useTranslation('cart');
  return (
    <span className={className} data-test="price-after-voucher-label">
      {t('priceAfterVoucher')}
    </span>
  );
};

export default CartPriceAfterVoucherLabel;
